import $ from 'jquery';

$( '.header-slider:not(.header-slider--sousou-init)' ).slick( {
	slidesToShow:   1,
	slidesToScroll: 1,
	arrows:         false,
	dots:           true,
	autoplay:       true,
	autoplaySpeed:  4000,
	accessibility:  false,
	draggable:      false,
	speed:          600,
	infinite:       true,
	lazyLoad:       "progressive"
} );
